import Packery from 'packery';

export default {
    init() {
        // JavaScript to be fired on all pages

        // Open external links and documents in new window
        $(document).ready(function(){
          $('a[href^="http://"], a[href^="/documents/"]').attr('target', '_blank');

          $('.loader').hide();

          // Grid Settings
          var grid = document.querySelector('.grid');

          if (grid) {
            grid.classList.add('visible');

            if( $(window).width() > 480 ) {
              new Packery(grid, {
                itemSelector: '.block',
              });
            }
          }
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js